import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_ENDPOINTS } from "../API/EndPoints";
import AxiosInstance from "../API/AxiosInstance";

export const getMedicalRecords = createAsyncThunk(
  "master/getMedicalRecords",
  async (credentials) => {
    const response = await AxiosInstance.get(API_ENDPOINTS.MEDICAL_RECORDS, {
      params: credentials,
    });
    return response.data;
  }
);

const medicalRecordSlice = createSlice({
  name: "getMedicalRecords",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMedicalRecords.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMedicalRecords.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(getMedicalRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default medicalRecordSlice.reducer;
